// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox-module__checkbox__6S0ju"};